
export const application = {
  'application.title': 'Demande de Subvention',
  'application.subtitle': 'Remplissez le formulaire pour demander cette subvention',
  'application.confirmationMessage': 'Votre demande a été reçue',
  'application.section1': 'Identité de la Ferme',
  'application.section2': 'Production',
  'application.section3': 'Finances',
  'application.section4': 'Technologie',
  'application.section5': 'Objectifs Stratégiques',
  'application.section6': 'Documents Supplémentaires',
  'application.formSaved': 'Votre brouillon de demande a été enregistré.',
  'application.prepareTitle': 'Préparez Votre Demande de Subvention',
  'application.prepareSubtitle': 'Préparons tous les documents nécessaires avant d\'accéder au portail officiel de l\'UE.',
  'application.documentChecklist': 'Liste de Documents',
  'application.docsReady': 'sur prêts',
  'application.officialDocument': 'Document officiel',
  'application.applicationForm': 'Formulaire de demande',
  'application.ready': 'Prêt',
  'application.prepComplete': 'Préparation de la Demande Terminée',
  'application.prepCompleteMessage': 'Tous les documents requis sont prêts. Vous pouvez maintenant accéder au portail officiel de l\'UE pour soumettre votre demande.',
  'application.platformSummary': 'Résumé des Actions de la Plateforme',
  'application.docsVerified': 'Documents téléchargés et vérifiés',
  'application.formsAutofilled': 'Formulaires remplis automatiquement avec les données de la ferme',
  'application.previewGenerated': 'Aperçu de la demande généré',
  'application.downloadDocs': 'Télécharger les Documents Complétés',
  'application.readyToApply': 'Prêt à Postuler',
  'application.readyToApplyMessage': 'Vous avez préparé tous les documents nécessaires. Cliquez ci-dessous pour accéder au portail officiel de subvention de l\'UE.',
  'application.extensionHelp': 'L\'extension Chrome AgriTool vous aidera automatiquement à remplir le formulaire de demande de l\'UE lorsque vous visiterez le site.',
} as const;
